module.exports = __webpack_public_path__ + "static/06-fa92665fad53e21c1a4ed1f21a4e6d24.jpg";